import { fetchJSON } from '../utils/fetch.ts';

export const fetchLicenseInformation = (cloudId: string): Promise<any> =>
	fetchJSON(`/gateway/api/xflow/${cloudId}/license-information`);
